import { Client } from 'nice-grpc-web';
import { DeepPartial } from '../customer_compiled/field_service';
import { GrpcClientFactoryType } from './types';
import {
  MaintenanceStatus_Response,
  StatusServiceDefinition,
  MaintenanceStatus_Request,
} from '../customer_compiled/status';

export default class MaintenanceStatusService {
  private static instance: MaintenanceStatusService;
  private readonly client: Client<typeof StatusServiceDefinition>;

  private constructor(grpcClientFactory: GrpcClientFactoryType) {
    this.client = grpcClientFactory<typeof StatusServiceDefinition>(StatusServiceDefinition);
  }

  static getInstance(grpcClientFactory: GrpcClientFactoryType) {
    if (!MaintenanceStatusService.instance) {
      MaintenanceStatusService.instance = new MaintenanceStatusService(grpcClientFactory);
    }

    return MaintenanceStatusService.instance;
  }

  maintenance(payload: DeepPartial<MaintenanceStatus_Request>): Promise<MaintenanceStatus_Response> {
    const request = MaintenanceStatus_Request.fromPartial(payload);
    return this.client.maintenance(request);
  }
}
